import { render } from "./VerifyEmailModal.vue?vue&type=template&id=65a20e04"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=js"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__